/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { ApplyPromoCodeErrorResponse, ApplyPromoCodeRequest } from './api.schemas';

import { api } from '../util/http';

export const createEncountersPromocode = (
  encounterId: number,
  applyPromoCodeRequest: ApplyPromoCodeRequest,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/api/encounters/${encounterId}/promocode`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: applyPromoCodeRequest,
    signal,
  });
};

export const getCreateEncountersPromocodeMutationOptions = <
  TError = ApplyPromoCodeErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEncountersPromocode>>,
    TError,
    { encounterId: number; data: ApplyPromoCodeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEncountersPromocode>>,
  TError,
  { encounterId: number; data: ApplyPromoCodeRequest },
  TContext
> => {
  const mutationKey = ['createEncountersPromocode'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEncountersPromocode>>,
    { encounterId: number; data: ApplyPromoCodeRequest }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return createEncountersPromocode(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEncountersPromocodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEncountersPromocode>>
>;
export type CreateEncountersPromocodeMutationBody = ApplyPromoCodeRequest;
export type CreateEncountersPromocodeMutationError = ApplyPromoCodeErrorResponse;

export const useCreateEncountersPromocode = <
  TError = ApplyPromoCodeErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEncountersPromocode>>,
      TError,
      { encounterId: number; data: ApplyPromoCodeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEncountersPromocode>>,
  TError,
  { encounterId: number; data: ApplyPromoCodeRequest },
  TContext
> => {
  const mutationOptions = getCreateEncountersPromocodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
